var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.html)?_c('v-card',[_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.html)}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }